import negativeKeywordResource from './negativeKeywordReource';
import negativeKeyword from '../shared/resource/negative-keywords';
import transformError from '../shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function addNegativeKeyword({ campaignId, keyword, matchingType }) {
  return negativeKeywordResource
    .addNegativeKeyword(
      {
        itemId: campaignId,
      },
      { keyword, matchingType },
    )
    .then(({ body: { message, data } }) => ({
      message,
      data: transformToCamelCase(data),
    }))
    .catch(transformError);
}

function getNegativeKeywords(campaignId) {
  return negativeKeywordResource
    .getNegativeKeywords({
      itemId: campaignId,
    })
    .then(({ body: negativeKeywords }) =>
      negativeKeywords.map(transformToCamelCase),
    )
    .catch(transformError);
}

export default {
  addBulkNegativeKeyword: negativeKeyword.addBulkNegativeKeyword,
  addNegativeKeyword,
  getNegativeKeywords,
};
